// src/pages/AuthDebug/AuthDebugScreen.js
import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';

function AuthDebugScreen() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return () => unsubscribe();
  }, []);

  const logout = () => {
    const auth = getAuth();
    signOut(auth).then(() => {
      console.log("🔓 Logget ut");
      setUser(null);
    });
  };

  return (
    <div style={{ padding: '2rem', color: 'white' }}>
      <h1>🛠️ Auth Debug</h1>
      {user ? (
        <>
          <p><strong>✅ UID:</strong> {user.uid}</p>
          <p><strong>Anonym:</strong> {user.isAnonymous ? '✅ Ja' : '❌ Nei'}</p>
          <button onClick={logout} style={styles.button}>Logg ut</button>
        </>
      ) : (
        <p>❌ Ikke logget inn.</p>
      )}
    </div>
  );
}

const styles = {
  button: {
    padding: '0.5rem 1.2rem',
    backgroundColor: '#ff4444',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    marginTop: '1rem',
    cursor: 'pointer',
  },
};

export default AuthDebugScreen;
